import customAxios from './axios';
import { PURCHASE_ORDER_V1_1 } from "../constants/api";

export function getPurchaseOrderById(id) {
    return customAxios.get(PURCHASE_ORDER_V1_1 + `/${id}`);
}